import React, {useEffect, useState} from 'react';
import {AiOutlinePlus} from "react-icons/ai";
import Todo from "./Todo";

import {db} from './firebase'
import {query, collection, onSnapshot, updateDoc, doc, addDoc, deleteDoc} from 'firebase/firestore'

const style = {
    bg: `h-screen w-screen p-4 bg-gradient-to-r from-[#00A6FF] to-[#90FCFF]`,
    container: `bg-slate-100 max-w-[500px] w-full m-auto rounded-md shadow-xl p-4`,
    heading: `text-3xl font-bold text-center text-gray-800 p-2`,
    form: `flex justify-between`,
    input: `border p-2 w-full text-xl`,
    button: `border p-4 ml-2 bg-blue-600 text-slate-100`,
    count: `text-center p-2`
}

function App() {
    const [todos, setTodos] = useState([``])
    const [input, setInput] = useState('')


    // Create todos
    const createTodo = async (e) => {
        e.preventDefault(e);
        if (input === ``) {
            alert(`Please enter a valid Todo`)
            // return to stop code
            return
        }
        await addDoc(collection(db, `todos`), {
            text: input, completed: true
        });
        setInput(``)
    };


    // Read todos
    useEffect(() => {
        const q = query(collection(db, `todos`))
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            let todosArr = [];
            querySnapshot.forEach((doc) => {
                todosArr.push({...doc.data(), id: doc.id})
            });
            setTodos(todosArr)
        });
        return () => unsubscribe();
    }, []);


    // Update todos
    const toggleComplete = async (todo) => {
        await updateDoc(doc(db, `todos`, todo.id), {
            completed: !todo.completed
        });
    }


    // Delete todos
    const deleteTodo = async (id) => {
        await deleteDoc(doc(db, 'todos', id))
    }


    return (<div className={style.bg}>
        <div className={style.container}>
            <h3 className={style.heading}>To Do App</h3>
            <form onSubmit={createTodo} className={style.form}>
                <input value={input} onChange={e => setInput(e.target.value)} className={style.input} type={"text"}
                       placeholder={"Add To Do"}/>
                <button className={style.button}><AiOutlinePlus size={30}/></button>
            </form>
            <ul>
                {todos.map((todo, index) => (
                    <Todo key={index} todo={todo} toggleComplete={toggleComplete} deleteTodo={deleteTodo}/>))}
            </ul>
            {todos.length < 1 ? "" : <p className={style.count}>{`You have ${todos.length} Todos`}</p>}
        </div>
    </div>);
}

export default App;
